var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _g2, _g3, _g4, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIa2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 236,
    viewBox: "0 0 343 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 109,
    rx: 19,
    fill: "url(#paint0_linear_481_112)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7412,
    y: 9.46533,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 69,
    width: 57,
    height: 29,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 34,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2588,
    y: 44,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2588,
    y: 54,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("rect", {
    y: 127,
    width: 103,
    height: 109,
    rx: 19,
    fill: "url(#paint1_linear_481_112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7412,
    y: 136.465,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 196,
    width: 57,
    height: 29,
    rx: 4,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 161,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2588,
    y: 171,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2588,
    y: 181,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    width: 103,
    height: 109,
    rx: 19,
    fill: "url(#paint2_linear_481_112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.741,
    y: 9.46533,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 69,
    width: 57,
    height: 29,
    rx: 4,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 34,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.259,
    y: 44,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.259,
    y: 54,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 127,
    width: 103,
    height: 109,
    rx: 19,
    fill: "url(#paint3_linear_481_112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.741,
    y: 136.465,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 196,
    width: 57,
    height: 29,
    rx: 4,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 161,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.259,
    y: 171,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.259,
    y: 181,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240,
    width: 103,
    height: 109,
    rx: 19,
    fill: "url(#paint4_linear_481_112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.741,
    y: 9.46533,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 69,
    width: 57,
    height: 29,
    rx: 4,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 34,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.259,
    y: 44,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.259,
    y: 54,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 127,
    width: 103,
    height: 109,
    rx: 19,
    fill: "url(#paint5_linear_481_112)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 250.741,
    y: 136.465,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 196,
    width: 57,
    height: 29,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 161,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 251.259,
    y: 171,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 251.259,
    y: 181,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_481_112",
    x1: 51.5,
    y1: 0,
    x2: 51.5,
    y2: 109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_481_112",
    x1: 51.5,
    y1: 127,
    x2: 51.5,
    y2: 236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_481_112",
    x1: 171.5,
    y1: 0,
    x2: 171.5,
    y2: 109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_481_112",
    x1: 171.5,
    y1: 127,
    x2: 171.5,
    y2: 236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_481_112",
    x1: 291.5,
    y1: 0,
    x2: 291.5,
    y2: 109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_481_112",
    x1: 291.5,
    y1: 127,
    x2: 291.5,
    y2: 236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIa2);
export default __webpack_public_path__ + "static/media/product-ia-2.26020d7097078fa94a65b16b74768ef1.svg";
export { ForwardRef as ReactComponent };